import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/* import auth from '../middleware/netherlands/auth' */
import guest from '../middleware/netherlands/guest'
import Welcome from '../netherlands/views/Welcome'
import CustomerDetails from '../netherlands/views/CustomerDetails'
import Checkout from '../netherlands/views/Checkout'
import Scanner from '../netherlands/views/Scanner'
import Login from '../netherlands/views/Login'
const routes = [
    { path: '/login', name: 'login', component: Login, meta: { middleware: guest } },
    { path: '/', name: 'welcome', component: Welcome, meta: { middleware: [guest]}},
    { path: '/checkout/customer-details', name: 'checkout-customer-details', component: CustomerDetails, meta: { middleware: [guest]}},
    { path: '/checkout', name: 'checkout', component: Checkout, meta: { middleware: [guest]}},
    { path: '/scanner', name: 'scanner', component: Scanner, meta: { middleware: [guest]}},
   
]

const router = new Router({
    mode: 'history',
    routes
})

function nextFactory(context,middleware,index) {
    const subsequentMiddleware = middleware[index]
    if(!subsequentMiddleware) return context.next
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context,middleware,index + 1);
        subsequentMiddleware({...context,next : nextMiddleware})
    }
}

async function beforeEach(to, from, next){

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
        const context = {
            from,
            next,
            router,
            to
        }
        const nextMiddleware = nextFactory(context, middleware, 1)
        return middleware[0]({ ...context, next: nextMiddleware })
    }

    return next()

}
router.beforeEach(beforeEach)

export default router
